import { Observable, ReplaySubject } from 'rxjs';

export const TIMEOUT = 'timeout';

const S_TO_MS = 1_000;


interface TaskOptions {
    args?: any;
    partCount?: number;
    timeout?: number;
}


export class Task<T> {
    readonly id: string;

    readonly resultId: string;

    readonly key: string;

    readonly args: any;

    readonly partCount: number;

    readonly timeout: number;

    private _result: ReplaySubject<T>;

    private finished = false;

    private actualCount: number;

    get result(): Observable<T> {
        return this._result.asObservable();
    }

    private timer: any;

    constructor(id: string, resultId: string, key: string, options: TaskOptions = {}) {
        this.id = id;
        this.resultId = resultId;
        this.key = key;
        this.args = options.args || {};
        this.partCount = options.partCount || 1;
        this.timeout = options.timeout || 5 * 60;
        this.actualCount = 0;
        this._result = new ReplaySubject<T>(options.partCount || 1);
        this.timer = setTimeout(() => this.error(TIMEOUT), this.timeout * S_TO_MS);
    }

    next(value: T) {
        if (this.finished) {
            return;
        }
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.error(TIMEOUT), this.timeout * S_TO_MS);
        this._result.next(value);
        this.actualCount++;
        if (this.actualCount === this.partCount) {
            this._complete();
        }
    }

    private _complete() {
        if (this.finished) {
            return;
        }
        clearTimeout(this.timer);
        this._result.complete();
        this.finished = true;
    }

    error(reason: string) {
        if (this.finished) {
            return;
        }
        clearTimeout(this.timer);
        this._result.error(reason);
        this.finished = true;
    }
}
